// extracted by mini-css-extract-plugin
export default {"suffix":"index_suffix__2xQpT","form":"index_form__t2eyo"};